/* 27.09.2026 — MUSE-Kaufbox (snippets/rlk-muse.liquid). Laedt nach rlk.js (defer).
   Nur echte Daten: Bewertungen aus [data-rlk-rev-daten] (Lieferanten-Bewertungen,
   Herkunftszeile steht im Titelblock), Lieferdaten aus RLK.logik (Werktage, Feiertage). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var OSTASIATISCH = /[぀-ヿ㐀-䶿一-鿿豈-﫿가-힯]/;
  var LATEIN_BUCHSTABE = /[A-Za-zÄÖÜäöüß]/;
  var PLATTFORM = new RegExp(['ali', 'ex', 'press'].join('\\s*') + '|chin' + 'a', 'i');

  /* ---------- Rabattcode kopieren ---------- */
  function initCode() {
    $$('[data-muse-code-kopieren]').forEach(function (k) {
      k.addEventListener('click', function () {
        var code = k.getAttribute('data-muse-code-kopieren');
        var ok = k.querySelector('[data-muse-code-ok]');
        function zeigen() { if (ok) { ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 1800); } }
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(zeigen, zeigen);
          else zeigen();
        } catch (e) { zeigen(); }
      });
    });
  }

  /* ---------- Bewertungen ---------- */
  function bewertungen() {
    var k = $('[data-rlk-rev-daten]');
    if (!k) return [];
    try { var a = JSON.parse(k.textContent); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function nameLesbar(n) {
    n = (n || '').trim();
    if (!n || /^(anonym|käufer|kaeufer)$/i.test(n) || PLATTFORM.test(n) || OSTASIATISCH.test(n)) return null;
    for (var i = 0; i < n.length; i++) { var z = n.charAt(i); if (/\p{L}/u.test(z) && !LATEIN_BUCHSTABE.test(z) && !/\p{Script=Latin}/u.test(z)) return null; }
    return n;
  }
  function initiale(n) { var z = (n || '').trim().charAt(0); return /\p{L}/u.test(z) ? z.toUpperCase() : null; }
  function textLesbar(b) { return b && b.length >= 25 && b.length <= 280 && !OSTASIATISCH.test(b); }
  function sterne(r) { var s = ''; for (var i = 1; i <= 5; i++) s += i <= r ? '★' : '☆'; return s; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function nachDatum(a, b) { return (b.d || '').localeCompare(a.d || ''); }

  function initSozial(liste) {
    $$('[data-muse-sozial]').forEach(function (box) {
      var anzahl = parseInt(box.getAttribute('data-anzahl'), 10) || 0;
      var namen = [], gesehen = {};
      liste.slice().sort(nachDatum).forEach(function (r) {
        if (namen.length >= 3 || (r.r || 0) < 4) return;
        var n = nameLesbar(r.n); var i = n && initiale(n);
        if (i && !gesehen[i]) { gesehen[i] = true; namen.push(i); }
      });
      if (namen.length < 3 || anzahl < 3) return;
      $('[data-muse-avatare]', box).innerHTML = namen.map(function (i, k) { return '<span class="rlk-muse-av rlk-muse-av--' + k + '">' + esc(i) + '</span>'; }).join('');
      $('[data-muse-namen]', box).textContent = namen.map(function (i) { return i + '.'; }).join(', ');
      var rest = anzahl - namen.length;
      $('[data-muse-weitere]', box).textContent = rest > 0 ? 'und ' + rest.toLocaleString('de-DE') + ' weitere haben beim Lieferanten bewertet' : 'haben beim Lieferanten bewertet';
      box.hidden = false;
    });
  }

  function initKarte(liste) {
    $$('[data-muse-karte]').forEach(function (box) {
      var auswahl = liste.filter(function (r) { return (r.r || 0) >= 4 && textLesbar(r.b); })
        .sort(function (a, b) { var la = a.b.length >= 60 ? 1 : 0, lb = b.b.length >= 60 ? 1 : 0; return (lb - la) || ((b.p && b.p.length ? 1 : 0) - (a.p && a.p.length ? 1 : 0)) || nachDatum(a, b); })
        .slice(0, 6);
      if (!auswahl.length) return;
      var buehne = $('[data-muse-karte-buehne]', box), i = 0;
      function zeige() {
        var r = auswahl[i], name = nameLesbar(r.n) || 'Käufer';
        var foto = r.p && r.p.length ? '<img class="rlk-muse-karte__foto" src="' + esc(r.p[0]) + '" alt="Kundenfoto" width="56" height="56" loading="lazy" referrerpolicy="no-referrer">' : '<span class="rlk-muse-karte__foto rlk-muse-karte__foto--leer" aria-hidden="true">' + esc(initiale(name) || 'K') + '</span>';
        buehne.innerHTML = foto + '<div class="rlk-muse-karte__inhalt"><p class="rlk-muse-karte__kopf"><b>' + esc(name) + '</b>' +
          '<span class="rlk-muse-karte__haken" aria-label="Käufer"><svg viewBox="0 0 20 20" width="13" height="13" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="currentColor"/><path d="M6 10.3l2.6 2.6L14 7.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<span class="rlk-muse-karte__sterne" aria-label="' + r.r + ' von 5 Sternen">' + sterne(r.r) + '</span></p>' +
          '<p class="rlk-muse-karte__text">' + esc(r.b) + '</p></div>';
      }
      $('[data-muse-karte-zurueck]', box).addEventListener('click', function () { i = (i - 1 + auswahl.length) % auswahl.length; zeige(); });
      $('[data-muse-karte-vor]', box).addEventListener('click', function () { i = (i + 1) % auswahl.length; zeige(); });
      if (auswahl.length < 2) $$('.rlk-muse-karte__pfeil', box).forEach(function (p) { p.hidden = true; });
      zeige();
      box.hidden = false;
    });
  }

  function initUgc(liste) {
    $$('[data-muse-ugc]').forEach(function (box) {
      var fotos = [], gesehen = {};
      liste.slice().sort(nachDatum).forEach(function (r) {
        if ((r.r || 0) < 4 || !r.p) return;
        r.p.forEach(function (u) { if (fotos.length < 3 && u && !gesehen[u]) { gesehen[u] = true; fotos.push(u); } });
      });
      if (fotos.length < 3) return;
      $('[data-muse-ugc-reihe]', box).innerHTML = fotos.map(function (u) {
        return '<li><a href="#rlk-reviews" aria-label="Zu den Bewertungen"><img src="' + esc(u) + '" alt="Kundenfoto aus einer Bewertung" loading="lazy" referrerpolicy="no-referrer" width="200" height="260"></a></li>';
      }).join('');
      box.hidden = false;
    });
  }

  /* ---------- Lieferzeitleiste mit Countdown ----------
     Alle Daten aus RLK.logik (Europe/Berlin, bundesweite Feiertage). Versandfertig
     in 1-2 Werktagen (AGB), Zustellung in lieferzeit_min-max Werktagen (Barans
     Angabe). Der Countdown laeuft bis zur naechsten Mitternacht, nach der sich das
     spaeteste Zustelldatum verschiebt – vorher bestellt, gilt das angezeigte Datum. */
  function initZeit() {
    var L = window.RLK && window.RLK.logik;
    if (!L) return;
    $$('[data-muse-zeit]').forEach(function (box) {
      var min = parseInt(box.getAttribute('data-liefer-min'), 10) || 1;
      var max = parseInt(box.getAttribute('data-liefer-max'), 10) || 8;
      function tagPlus(t, n) { var d = new Date(Date.UTC(t.y, t.m - 1, t.d) + n * 864e5); return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate() }; }
      function gleich(a, b) { return a.y === b.y && a.m === b.m && a.d === b.d; }
      function lauf() {
        var jetzt = L.berlin(new Date());
        var heute = { y: jetzt.y, m: jetzt.m, d: jetzt.d };
        var bis = L.versandfertigBis(heute, max);
        $('[data-muse-zeit-versandt]', box).textContent = L.datumKurz(L.versandfertigBis(heute, 1)) + ' – ' + L.datumKurz(L.versandfertigBis(heute, 2));
        $('[data-muse-zeit-zugestellt]', box).textContent = L.datumKurz(L.versandfertigBis(heute, min)) + ' – ' + L.datumKurz(bis);
        var tage = 1;
        for (; tage <= 5; tage++) if (!gleich(L.versandfertigBis(tagPlus(heute, tage), max), bis)) break;
        var rest = tage * 1440 - (jetzt.h * 60 + jetzt.min);
        var h = Math.floor(rest / 60), mi = rest % 60;
        $('[data-muse-zeit-kopf]', box).innerHTML = 'Wenn du innerhalb von <b>' + h + ' Std. ' + mi + ' Min.</b> bestellst, bekommst du es bis <b>' + esc(L.datumKurz(bis)) + '</b>';
      }
      lauf();
      setInterval(lauf, 30000);
    });
  }

  function start() {
    initCode();
    var liste = bewertungen();
    if (liste.length) { initSozial(liste); initKarte(liste); initUgc(liste); }
    initZeit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
